import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { CustomerComplianceCheckEmailModel, GetComplianceCheckResponse } from "../models/due-diligence.models";


@autoinject()
export class ComplianceCheckApi {

    public dueDiligenceComplianceCheckClientApi: string = `${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/ComplianceCheck`;

    constructor(private configService: ConfigService, private requestClient: RequestClientService){}

    public getCustomerComplianceTeamEmails(customerId: number): Promise<GetComplianceCheckResponse> {
        return this.requestClient.get<GetComplianceCheckResponse>(`${this.dueDiligenceComplianceCheckClientApi}/${customerId}`, {});
    }
    
    public getComplianceTeamEmails(): Promise<GetComplianceCheckResponse> {
        return this.requestClient.get<GetComplianceCheckResponse>(`${this.dueDiligenceComplianceCheckClientApi}`, {});
    }

    public updateComplianceCheckEmails(complianceCheckEmails: CustomerComplianceCheckEmailModel[], customerId?: number): Promise<void> {
        return this.requestClient.post(`${this.dueDiligenceComplianceCheckClientApi}`, {}, {customerId: customerId, complianceChecks: complianceCheckEmails});
    }
}
